import axios from 'axios';
// import store from '@/store/index'
// import router from '@/router/index'
import { MessageBox, Message } from 'element-ui';
import router from '@/router';
import qs from 'qs';
import $ from 'jquery';
import store from '@/store';

const service = axios.create({
  baseURL: '',
  timeout: 1000000,
});
let loginOnce = false;
// http request 拦截器
service.interceptors.request.use(
  config => {
    console.log(store.getters['account/token'])
    config.headers['token']=store.getters['account/token']
    if (config.params) {
      config.params = {
        ...config.params,
        v: new Date().getTime(), // Get 请求加个时间戳
      };
      config.headers['token'] =config.params.token || store.getters['account/token']
    }
    if (config.data) {
      // eslint-disable-next-line no-irregular-whitespace
      // console.log('请求入参', JSON.stringify(config.data));
      config.headers['token'] =config.data.token || store.getters['account/token']
      // 这块会导致浏览器内存溢出情况 json序列化的字符串过于庞大（几十m的字符串数据 属于异常情况）
      if (config.headers['Content-Type'] == 'application/json') {
        config.data = JSON.stringify(config.data);
      } else if (config.headers['Content-Type'] == 'multipart/form-data') {
        // config.data = JSON.stringify(config.data);
      } else {
        config.data = qs.stringify(config.data);
      }
    }
    const { url } = config
    //TODO:测试
    if (url.indexOf('login') === -1 && !config.headers['token']) {
      
      Message.warning('认证 token 已过期，请重新登录')
      router.push("/login")
      
    }
    
    // token: config.data.token || store.getters['user/_token'], }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    // console.log(response, response.data, 'res');
    switch (response.data.errno) {
      case 0:
        return response.data;
      case 401:
        //Token问题登入问题
        if (!loginOnce) {
          loginOnce = true;
          Message({
            message: response.data.errmsg,
            type: 'error',
            duration: 3 * 1000,
          });
          setTimeout(function() {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
            loginOnce = false;
            return;
          }, 1000);
        }
        return response.data;
      case 403:
        Message({
          message: response.data.errmsg || '请求出错，请稍后重试',
          type: 'error',
          duration: 3 * 1000,
        });
        return response.data;
      default:
        Message({
          message: response.data.errmsg || '请求出错，请稍后重试',
          type: 'error',
          duration: 3 * 1000,
        });
        // return Promise.reject(response.data);
        return response.data;
    }
  },
  error => {
    console.log('err' + error); // for debug
    let message = error.status == 500 ? '服务器出错' : error.message;
    Message({
      message: message,
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error.response);
  }
);
export default service;
